import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListDownloading = createSelector([
  getProjectListState,
], (state) => state.downloading);
